const triviaCategories = [
  {type: 'Animals', value: 27},
  {type: 'Art', value: 25},
  {type: 'Celebrities', value: 26},
  {type: 'Entertainment: Board Games', value:16},
  {type: 'Entertainment: Books', value: 10},
  {type: 'Entertainment: Cartoon & Animations', value: 32},
  {type: 'Entertainment: Comics', value: 29},
  {type: 'Entertainment: Film', value: 11},
  {type: 'Entertainment: Japanese Anime & Manga', value: 31},
  {type: 'Entertainment: Music', value: 12},
  {type: 'Entertainment: Musicals & Theatres', value: 13},
  {type: 'Entertainment: Television', value: 14},
  {type: 'Entertainment: Video Games', value: 15},
  {type: 'General Knowledge', value: 9},
  {type: 'Geography', value: 22},
  {type: 'History', value: 23},
  {type: 'Mythology', value: 20},
  {type: 'Politics', value: 24},
  {type: 'Science & Nature', value: 17},
  {type: 'Science: Computers', value: 18},
  {type: 'Science: Gadgets', value: 30},
  {type: 'Science: Mathematics', value: 19},
  {type: 'Sports', value: 21},
  {type: 'Vehicles', value: 28}
]

export default triviaCategories
